import React from "react";
import { findPathIntersection } from "oc-app/metadata/GraphMetadata";
import { NumberSelect } from "../components/NumberSelect";
import { TitleBlock } from "./OptionSelect";
import { getAuswahlData } from "./MHelper";

export function E_Antrieb_Zubehoer() {
  const element = APP.arrangement.getCurrentElement();
  const eAntriebAuswahlData = getAuswahlData("E_Antrieb_Zubehör");
  const zubehoerType = element.isSchiebetor ? "Schiebetor_Zubehör" : "E_Antrieb_Zubehör";
  const erlaubteAuswahlwertKeys = new Set(
    APP.metadata.Zubehoer.filter((z) => z.Type === zubehoerType).map((z) => z.Auswahlwert?.Key)
  );
  const eAntriebZubehörAuswahlwerte = APP.metadata.Auswahlwert.filter(
    (aw) => aw.Auswahl.Key == "E_Antrieb_Zubehör" && erlaubteAuswahlwertKeys.has(aw.Key)
  );

  return (
    <section
      className="zubehör-container optionSelect"
      aria-labelledby="e-antrieb-zubehoer-title"
      role="region"
    >
      <TitleBlock auswahlData={eAntriebAuswahlData} />
      <div
        className="zubehör-items"
        role="list"
        aria-label={I18N("Verfügbares Zubehör für E-Antrieb")}
      >
        {eAntriebZubehörAuswahlwerte.map((auswahlwert) => (
          <div key={auswahlwert.Key} role="listitem" className="zubehör-item">
            <NumberSelect
              title={auswahlwert.Name}
              auswahlwert={auswahlwert}
              minAnzahl={findPathIntersection(auswahlwert, (a) => (a as any).Zubehoer.MinAnzahl)}
              maxAnzahl={findPathIntersection(auswahlwert, (a) => (a as any).Zubehoer.MaxAnzahl)}
              value={element.zubehörAnzahl[auswahlwert.Key]}
              onChange={(v) => {
                element.zubehörAnzahl[auswahlwert.Key] = v;
                APP.dirty();
              }}
            />
          </div>
        ))}
      </div>
    </section>
  );
}
